// angular
import { Injectable, EventEmitter, Inject, Injector } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';

// config 
import { Configuration } from '../configurations/shared.config';

// models
import { IErrorHandler } from '../dataModels/contracts/IErrorHandler';
import { LookUpTableName } from '../dataModels/data-models';
import { Sensor, VehicleCanbus } from '../dataModels/sensors-tab-form';
import { IErrorHandlerToken, Filtration, FilterCriteria } from '../dataModels';
import { DiagnosedItem } from '../dataModels/diagnosed-item';

// pipes
import { LocalizePipe } from '../pipes/Localize.pipe';

@Injectable()
export class SensorTabService extends DiagnosedItem {

    public deleteSelectedEvent: EventEmitter<any> = new EventEmitter<any>();
    public saveSensorEvent: EventEmitter<any> = new EventEmitter<any>();

    constructor(private _http: Http, @Inject(IErrorHandlerToken) private _errorHandler: IErrorHandler, private _localizer: LocalizePipe, private __inj: Injector) {
        super(__inj);
    }

    save(model: Sensor) {

        //save sensor
        this._http.post(Configuration.urls.webApiEndpoint + Configuration.urls.sensorUrl, model)
            .map(res => res.json())
            .subscribe(result => this.saveSensorEvent.emit(result), err => this._errorHandler.DefaultError());
    }
    DeviceConfiguration(VechileId) {
        //DeviceConfiguration
        return this._http.get(Configuration.urls.webApiEndpoint + Configuration.urls.GetDeviceModelConfiguration + VechileId)
            .map(res => res.json())

    }
    deleteSelected(sensorList): void {
        if (sensorList.length > 0) {
            this._http.post(Configuration.urls.webApiEndpoint + Configuration.urls.removeSenesorUrl, sensorList)
                .map(res => res.json())
                .subscribe(result => {

                    //if not error
                    if (result && !result.IsErrorState) {

                        //this.listView.Refresh(this.transporterList.Collection.length == 1);
                        this.deleteSelectedEvent.emit(true);
                    }
                    else {
                        this._errorHandler.DefaultError();
                    }
                }, err => this._errorHandler.DefaultError());
        }
    }
    getCanbusDefaultData(filtration) {
        return this._http.post(Configuration.urls.webApiEndpoint + Configuration.urls.GetModelCanbusSensor, filtration).map(res => res.json());
    }
    getSensorData(filterCriteria: FilterCriteria) {
        return this._http.post(Configuration.urls.webApiEndpoint + Configuration.urls.filterSensorUrl, filterCriteria).map(res => res.json());
    }
    saveCanbusData(vehicleCanbus: VehicleCanbus) {
        return this._http.post(Configuration.urls.webApiEndpoint + Configuration.urls.saveCanbus, vehicleCanbus).map(res => res.json());
    }
    deleteCanbusData(vehicleId: number) {
        return this._http.get(Configuration.urls.webApiEndpoint + Configuration.urls.deleteCanbus + '/' + vehicleId).map(res => res.json());
    }
    getVehiclePolicy(vehicleId) {
        return this._http.get(Configuration.urls.webApiEndpoint + Configuration.urls.GetDefaultPolicy + vehicleId).map(res => res.json())
    }
    getRuleByVehicle(vehicleId) {
        return this._http.get(Configuration.urls.webApiEndpoint + Configuration.urls.GetRuleByVehicle + vehicleId).map(res => res.json())
    }
    // end methods
    getSensorLocal(obj) {
        return this._http.post(Configuration.urls.webApiEndpoint + Configuration.urls.GetSensorLocal, obj).map(res => res.json());
    }
    // end methods

}



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/sensors-tab-form.service.ts